import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"texture"}/>
}
